//*******************************************************
import {  Component,
          ChangeDetectorRef 
        } from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
// Field Definitions
import  { 
  inviteefield,
  whoseguestinit,
  listtableseating  
}                                         from '../../appfirestore/app.fields';
//*******************************************************     
// Devexpress 
import { DxTileViewComponent }            from 'devextreme-angular';
//*******************************************************
// Functions
import { appfunctions  }                  from '../../functions/app.functions';
//*******************************************************
@Component(
            {
              selector: 'app-cominviteeseating',
              templateUrl: './cominviteeseating.component.html',
              styleUrls: ['./cominviteeseating.component.scss']
            }
          )
//*******************************************************
export class CominviteeseatingComponent 
{
      //*******************************************************
      eventid: string = '';
      formheight: number = 0;

      // Firestore Paths
      pathinvitee: string       = "/eventinvitee/inviteelist";
      pathtableseatlist: string = "/eventtableseatlist/tableseatlist";

      // eventinvitee
      subscriptioninviteeconfirmBUTNOtable: Subscription;
      subscriptioninviteeconfirmBUTNOTablelist: inviteefield[];

      // tableseatno
      subscriptioninviteetableseatno: Subscription;
      subscriptioninviteetableseatnolist: listtableseating[];

      whoseguest: Array<whoseguestinit> = []; // Empty Array

      dragitem: string;
      dragitem_inviteeid: string;

      dragfromcomponent: string;
      dragtocomponent: string;
      dragitemindex: number;
      dragitem_tableid: string;
      dragitem_inviteename: string;

      seltableid: string = '';
      seltablename: string = '';
      seltableorder: number = 0;

      popupVisible: boolean = false;
      positionOf: string;

      tablehint: string = '';
     //*******************************************************
     constructor (
                   private routernavigate: Router,
                   private firestoredata: firestorecontrol, 
                   private cdRef : ChangeDetectorRef,
                   private appfunction: appfunctions,
                   private _Activatedroute:ActivatedRoute
                 ) 
       { 

        this.onAdd                  = this.onAdd.bind(this);
        this.onRemove               = this.onRemove.bind(this);
        this.onReorder              = this.onReorder.bind(this);

        this.onDragStartInviteeName = this.onDragStartInviteeName.bind(this);
        this.onDragStart            = this.onDragStart.bind(this);

        this.saveTableNameClick   = this.saveTableNameClick.bind(this);
        this.cancelTableNameClick = this.cancelTableNameClick.bind( this); 
       }
     //*******************************************************
     ngOnInit(): void 
       {
          //---------------------------------------------------------------------------------------------
          // EventId
          this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
          // Form Height
          this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
          //---------------------------------------------------------------------------------------------
          // Establish Connection to event -> eventparticipant
          this.firestoredata.loadeventinviteecomingBUTNOTable( this.eventid );

          this.subscriptioninviteeconfirmBUTNOtable = this.firestoredata.geteventinviteecomingBUTNOTable().subscribe
            ( items => 
              { 
                this.subscriptioninviteeconfirmBUTNOTablelist = items;
               // console.log( this.subscriptioninviteeconfirmBUTNOTablelist )
              }
            )
          //---------------------------------------------------------------------------------------------
          // Establish Connection to event -> tableseat
          this.firestoredata.loadtableseatcard( this.eventid );

          this.subscriptioninviteetableseatno = this.firestoredata.geteventtableseatlist().subscribe
            ( items => 
              { 
                this.subscriptioninviteetableseatnolist = items;
               //console.log( this.subscriptioninviteetableseatnolist )
              }
            )
          //---------------------------------------------------------------------------------------------
          // Event Organiser Initials
          this.firestoredata.buildwhoseguestdetails( this.eventid );
          this.whoseguest = this.firestoredata.geteventparticipantdetails();
          //---------------------------------------------------------------------------------------------
       }
     //*******************************************************
     ngAfterViewChecked()
      {
       // this.cdRef.detectChanges();
      }
    //*******************************************************
     ngOnDestroy() 
       {
        this.subscriptioninviteeconfirmBUTNOtable.unsubscribe();    
       }
    //*******************************************************
    onClickNewTable( event: any )
      {
        this.firestoredata.crudeventtable( this.eventid )
      }
    //*******************************************************  
    // Adding Invitee Name to Table
    onAdd(e) 
      {
        //console.log( e )
        // Component whhere Item is being Drag from
        this.dragfromcomponent = e.fromComponent.NAME;
        this.dragtocomponent   = e.toComponent.NAME;

        console.log(  'From:' + this.dragfromcomponent + ' ' + 'To:' + this.dragtocomponent )
        //---------------------------------------------------------------------------------------------
        // From: dxdatagrid to dxlist
        if ( ( this.dragfromcomponent.toUpperCase()  == 'DXDATAGRID') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
          {
            // Firestore -> tableid
            this.dragitem_tableid = this.extract_invitationid( 10, e.toData[0], ':' );

            //console.log(  this.dragitem_tableid )

            // Add Invitee to Seat List
            e.toData.splice(e.toData.length,  0,  this.dragitem );

            // Update Firestore -> Invitee -> tableid
            this.firestoredata.commitbatchupdate( 
                                                    this.pathinvitee, 
                                                    this.eventid,
                                                    this.dragitem_inviteeid,
                                                    'table', 
                                                    this.dragitem_tableid
                                                );

            // Update Firestore -> Invitee -> seatno
            this.firestoredata.commitbatchupdate( 
                                                    this.pathinvitee, 
                                                    this.eventid,
                                                    this.dragitem_inviteeid,
                                                    'seatno', 
                                                    this.dragitem
                                                );

            // Update Firestore -> Table -> list
            this.firestoredata.commitbatchupdate( 
                                                  this.pathtableseatlist, 
                                                  this.eventid,
                                                  this.dragitem_tableid,
                                                  'inviteename', 
                                                  e.toData
                                                );

          }
        //---------------------------------------------------------------------------------------------
        // From: dxlist to dxlist
        if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') )
          {

            if ( this.dragitemindex != 0 )
              {
                
                this.dragitem_tableid = this.extract_invitationid( 10, e.toData[0], ':' );
                this.dragitem_inviteeid = this.extract_invitationid( 20, this.dragitem, '[' );
            
                // Add Invitee to Destination -> Table List
                e.toData.splice(e.toData.length,  0,  this.dragitem );

                // Update Firestore -> Invitee -> tableid
                this.firestoredata.commitbatchupdate( 
                                                        this.pathinvitee, 
                                                        this.eventid,
                                                        this.dragitem_inviteeid,
                                                        'table', 
                                                        this.dragitem_tableid
                                                    );

                // Update Firestore -> Table -> list
                this.firestoredata.commitbatchupdate( 
                                                      this.pathtableseatlist, 
                                                      this.eventid,
                                                      this.dragitem_tableid,
                                                      'inviteename', 
                                                      e.toData
                                                    );
              }
            
        }
        //---------------------------------------------------------------------------------------------
        // From: dxdatagrid to dxlist
        if ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXDATAGRID') )
          {
            //console.log( 'Cannot drop')
            e.cancel = true;
          }
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    onRemove(e) 
      {

        this.dragfromcomponent = e.fromComponent.NAME;
        this.dragtocomponent   = e.toComponent.NAME;

        console.log(  'From:' + this.dragfromcomponent + ' ' + 'To:' + this.dragtocomponent )
        //if ( 
        //  ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXLIST') ) || 
        //  ( ( this.dragfromcomponent.toUpperCase()  == 'DXLIST') && ( this.dragtocomponent.toUpperCase()  == 'DXDATAGRID') )

          if ( this.dragfromcomponent.toUpperCase() == 'DXLIST' &&  this.dragtocomponent.toUpperCase()  == 'DXLIST' ) 
          {
            if ( this.dragitemindex != 0 )
              {
                console.log( 'Remove:' + this.dragitemindex )

                // Source - Invitee List
                e.fromData.splice( this.dragitemindex, 1 );

                // Update Firestore -> Table List
                this.dragitem_tableid = this.extract_invitationid( 10, e.fromData[0], ':' );

                // Remove Invitee from From Table
                this.firestoredata.commitbatchupdate( 
                                                      this.pathtableseatlist, 
                                                      this.eventid,
                                                      this.dragitem_tableid,
                                                      'inviteename', 
                                                      e.fromData
                                                    );
              }
          
          }

      }
    //******************************************************* 
    onReorder(e)
      {
        //console.log( e )
        if (e.toIndex === 0)
          {
            //console.log( 'James')
            e.cancel = true;
          }
        else
          {
            
            e.fromData.splice( e.fromIndex, 1)            // Delete Index
            e.fromData.splice( e.toIndex,0, e.itemData)   // ReOrder Invitee

            // Save back to firestore
            // Update Firestore -> Table -> list
            this.dragitem_tableid = this.extract_invitationid( 10, e.fromData[0], ':' );
            this.firestoredata.commitbatchupdate( 
                                                    this.pathtableseatlist, 
                                                    this.eventid,
                                                    this.dragitem_tableid,
                                                    'inviteename', 
                                                    e.fromData
                                                  );
            
          }

      }
    //*******************************************************
    // Dragging Invitee Details frpm DataGrid
    onDragStartInviteeName(e) 
    {
    
      // Invitee Id
      this.dragitem_inviteeid = e.itemData.id;
      // Key Identification
      this.dragitem           = e.itemData.firstname + ' ' + e.itemData.lastname + ' - [' +  e.itemData.id + ']' ;

      //  console.log (  this.dragitem_inviteeid  + ' ' + this.dragitem )
    }
    //*******************************************************
    // Tile Click
    tileselect( event: any)
      {

     //   this.seltableid     = event.itemData.id 
    //    this.seltablename   = event.itemData.table
      //  this.seltableorder  = event.itemData.tableorder;

     //   this.positionOf   =  `#tileview${event.itemData.id}`;
      //  this.popupVisible = true;
        //this.build_invitee_deliveryoptions( event.itemData.id, event.itemData.inviteename )

      }
    //*******************************************************
    onTableAssignClicked(e)
      {
          console.log( e.id )


          this.seltableid     = e.id 
          this.seltablename   = e.table
          this.seltableorder  = e.tableorder;

          this.positionOf   =  `#tileview${e.id}`;
          this.popupVisible = true;
      
         // this.build_invitee_deliveryoptions( e.id, event.itemData.inviteename )
      }
  //*******************************************************
    onDragStart(e) 
      {
        e.itemData = e.fromData[e.fromIndex];

        this.dragitemindex = e.fromIndex   // Prevent dragitemindex = 0 from being dragged.

       // console.log(  this.dragitemindex )
  
        if ( e.fromIndex == 0 )
          {
            // Cannot Drag Row 1 of List
            e.cancel = true;
          }
        else
          {
            this.dragitem               = e.itemData 
            this.dragitem_inviteename   = this.extract_invitationid( 30, e.itemData, '-' )
          }

      }
    //*******************************************************
    inviteeonItemDeleted( event: any, invitelist: any )
      {
        // console.log( event.itemData )
        this.dragitem_tableid   = this.extract_invitationid( 10,  invitelist[0], ':' );
        this.dragitem_inviteeid = this.extract_invitationid( 20, event.itemData, '[' );

        //console.log( this.dragitem_tableid )
        //console.log( this.dragitem_inviteeid )
        //---------------------------------------------------------------------------------------------
        // Update Firestore -> Invitee -> tableid
        this.firestoredata.commitbatchupdate( 
                                              this.pathinvitee, 
                                              this.eventid,
                                              this.dragitem_inviteeid,
                                              'table', 
                                              '0'
                                            );
        //---------------------------------------------------------------------------------------------  
        // Update Firestore -> Table -> list
        this.firestoredata.commitbatchupdate( 
                                              this.pathtableseatlist, 
                                              this.eventid,
                                              this.dragitem_tableid,
                                              'inviteename', 
                                              invitelist
                                            );
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    extract_invitationid( splittype: number, seltext: string, selsplit: string )
    {

      var retvalue: string;

      switch ( splittype )
        {
          case 10:
              {
                let invitationlistid = seltext.split(selsplit);
    
                retvalue =  invitationlistid[1].trim();
                break
              }

          case 20:
              {
                let invitationlistid = seltext.split(selsplit);

                retvalue = invitationlistid[1].trim();
                retvalue = retvalue.substring(0,4);
  
                break
              }

          case 30:
              {
                let invitationlistid = seltext.split(selsplit);
    
                retvalue =  invitationlistid[0].trim();
                break
              }
        
        }

      return retvalue;

    }
  //*******************************************************
  // Save Collaborator Detail 
  saveTableNameClick( { validationGroup })
    {
      const result = validationGroup.validate();
      if (result.isValid) 
        {
          this.firestoredata.crudsettableprofile( this.eventid,  this.seltableid,  this.seltablename,  this.seltableorder );
          this.popupVisible = false;
        } 
     
    }
  //*******************************************************
  cancelTableNameClick()
    {
      this.popupVisible = false;
    }
  //*******************************************************
  btnmouseover( e: any )
  {
     if ( e.table == 'Table Name TBC')
       {
         this.tablehint = 'shshshshshshshs'
       }
     else
       {
         this.tablehint = e.delivery;
       }
  }
 //*******************************************************
}
